import {useState, useEffect} from 'react'
import {Spinner} from 'react-bootstrap'

import { adminAPI } from '../../../api';

import { ContentFeatureSettings } from './ContentFeatureSettings';

import { APP_NAME } from '../../../utils'

interface Props {
}

const Settings : React.FC<Props> = ({}) => {

  const [project, setProject] = useState<any>(null)

  useEffect(() => {
    loadDefaultProject()
  }, [])

  async function loadDefaultProject(){
    if( APP_NAME ){
      let {data: data} = await adminAPI.getProject(APP_NAME)
      setProject(data['data'])
    }
  }

  return <div className="card">
      <div className="card-body">
        {project ? 
        <ContentFeatureSettings project={project} setProject={setProject} />
        :
        <Spinner animation='border'/>
      }
    </div>
  </div>
}

export default Settings